export const OPEN_SEARCH_EVENT = "shell:open-search";

/** The header button, the sidebar button and Ctrl/Cmd+K all open the same menu search. */
export function openMenuSearch() {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(OPEN_SEARCH_EVENT));
}
